module.exports = __webpack_public_path__ + "img/search.6b10ebd9.svg";